import { urlBase64ToUint8Array } from './vapid'
import { apiClient } from '@/lib/api/client'

export async function registerPushSubscription(
  registration: ServiceWorkerRegistration,
): Promise<PushSubscription | null> {
  const vapidKey = import.meta.env.VITE_VAPID_PUBLIC_KEY
  if (!vapidKey) {
    console.warn('VAPID public key not configured')
    return null
  }
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(vapidKey) as BufferSource,
  })
  await apiClient('/api/v1/users/me/push-subscriptions', {
    method: 'POST',
    body: JSON.stringify(subscription.toJSON()),
  })
  return subscription
}
